const isCallCenterHighlightColor = (color = '') => {
  const normalizedColor = color.toLowerCase().replace(/\s+/g, '')
  return normalizedColor === 'orange' || normalizedColor === '#ffa500' || normalizedColor === 'rgb(255,165,0)' || normalizedColor === 'rgba(255,165,0,1)'
}

export const sanitizeCallCenterHtmlForDisplay = (html = '') => {
  if (typeof html !== 'string') return ''

  return html
    .replace(/(?:background-color|background)\s*:\s*[^;"']*;?/gi, '')
    .replace(/(?:font(?:-[a-z-]+)?|text-decoration|letter-spacing)\s*:\s*[^;"']*;?/gi, '')
    .replace(/(^|[;"'\s])color\s*:\s*([^;"']*);?/gi, (match, prefix, color) =>
      isCallCenterHighlightColor(color) ? `${prefix}color: orange;` : prefix,
    )
    .replace(/\sbgcolor\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '')
    .replace(/\s(?:color|face|size)\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '')
    .replace(/<\/?(?:b|strong|i|em|u|font)\b[^>]*>/gi, '')
}
